module.exports = __webpack_public_path__ + "img/q1.352b772a.png";